import React, { forwardRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useHistory } from "react-router-dom";
import ApplicaionFormatView from "./ApplicationView";
import { Loader } from "@egovernments/digit-ui-react-components";
import NOCFormatView from "./NOCFormatView";
import OwnerSummary from "../../obps/src/pages/citizen/AVPForms/formComponents/owner-registration/Step4";
import ApplicaionFormatViewNew from "./ApplicationFormatViewNew";

const TakeActionItem = forwardRef(({ id, formType, logoData, oldCaseSearch }, ref) => {
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("EMPLOYEE");
  const { data = {}, isLoading, refetch } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id, isEmployee, formType }, { formType });
  const { data: { BPA: { logoStore } = {} } = {}, isLoading: isLogoLoading } = Digit.Hooks.obps.useMDMS("up", "BPA", ["logoStore"]);

  const avpLogo = logoStore?.find((item) => item.code === "up.avp");
  const daLogo = logoStore?.find((item) => item.code === "up.da");
  useEffect(() => {
    if (id && formType) {
      refetch();
    }
  }, [id, formType, refetch]);
  console.log(data, "fromTakeAction");

  const formData = data?.LandUse?.[0] || data?.ownerRegistration?.[0] || data?.PurchasableFAR?.[0] || data?.BPA?.[0] || data?.applicationData;
  const { collectionBillRes, collectionBillDetails } = data;
  if (!isLoading && formData) {
    formData.paymentDetails = collectionBillRes?.[0]?.paymentDetails?.[0];
  }

  let consumerCode = id;
  const fetchBillParams = { consumerCode };
  const appType = formData?.applicationType;
  const BusinessService = formData?.businessService === `BPA_${appType?.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;

  const { data: paymentDetails } = Digit.Hooks.useFetchBillsForBuissnessService(
    { businessService: BusinessService, ...fetchBillParams, tenantId: stateId },
    {
      enabled: consumerCode ? true : false,
      retry: false,
    }
  );
  // const paymentDetails = "89889" ;
  const totalAmount = formData?.paymentDetails?.bill?.billDetails[0]?.amount || paymentDetails?.Bill?.[0]?.billDetails[0]?.amount;

  //Documents
  const docs = formData?.documents || {};
  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;

  // formData.documents = documents;
  // for application documents
  let improvedDoc = [];
  formData?.PrevStateDocuments?.map((preDoc) => {
    improvedDoc.push({ ...preDoc, module: "OBPS" });
  });
  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });
  //for NOC documents
  formData?.PrevStateNocDocuments?.map((preNocDoc) => {
    improvedDoc.push({ ...preNocDoc, module: "NOC" });
  });
  formData?.nocDocuments?.nocDocuments?.map((nocDoc) => {
    improvedDoc.push({ ...nocDoc, module: "NOC" });
  });

  const { data: pdfDetails, isLoading: pdfLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, { enabled: improvedDoc?.length > 0 ? true : false });

  let applicationDocs = [],
    nocAppDocs = [];
  if (pdfDetails?.pdfFiles?.length > 0) {
    console.log(pdfDetails, "fromTakeActionDOcs");
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module === "OBPS") applicationDocs.push(pdfAppDoc);
      if (pdfAppDoc?.module === "NOC") nocAppDocs.push(pdfAppDoc);
    });
  }

  if (pdfLoading) {
    return <Loader />;
  }
  return (
    <React.Fragment>
      {formType === "formNOC" ? (
        <NOCFormatView formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
      ) : formType === "OWNER_REGISTRATION" ? (
        <OwnerSummary formData={formData} ref={ref} />
      ) : (
        <ApplicaionFormatViewNew
          ref={ref}
          formData={formData}
          applicationDocs={applicationDocs}
          totalAmount={totalAmount}
          logoData={formData?.department === "DA" ? daLogo : avpLogo}
          oldCaseSearch={oldCaseSearch}
        />
      )}
    </React.Fragment>
  );
});

export default TakeActionItem;
